import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import ReportStudent,{ReportStudentRoutes} from './StudentReport/index'; 
import ReportLibrary,{ReportLibraryRoutes} from './LibraryReport/index'; 
import FineReport from './FineReport/fineReport'; 
import QrCodeReport from './QrCodeReport/qrcodeReport'; 
 
export  const ReportsRoutes = [
    {
        path: '/student',
        name:'Student Report',
        component: ReportStudent,
        routes:ReportStudentRoutes,
        show:true,
    },
    {
        path: '/fine-report',
        name:'Fine Report',
        component: FineReport,
        show:true,
    }, 
    {
        path: '/qrcode-report',
        name:'QRCode Report',
        component: QrCodeReport,
        show:true,
    },
    {
        path: '/library',
        name:'Library Report',
        component: ReportLibrary,
        routes:ReportLibraryRoutes,
        show:true,
    },
];

const Reports = (props) => { 
    return(
        <Switch>
            {ReportsRoutes.map((route) => 
                <Route 
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Reports; 


// WEBPACK FOOTER //
// ./src/components/Reports/index.js